<template>
  <transition name="expand">
    <v-row v-if="isOpen" class="mx-0" :class="$vuetify.display.xs ? 'mt-3' : 'mt-4'">
      <v-col cols="12" class="rounded" :class="$vuetify.display.xs ? 'pa-3' : 'pa-4'" style="background-color: #f1f1f1">
        <!-- Header with close button -->
        <div class="d-flex justify-space-between align-center" :class="$vuetify.display.xs ? 'mb-2' : 'mb-3'">
          <h3 class="text-h6 font-weight-bold ma-0" style="color: #191919">Course Details</h3>
          <v-btn icon size="small" variant="text" @click="$emit('close')" style="color: #747474">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Course Description Section -->
        <div :class="$vuetify.display.xs ? 'mb-3' : 'mb-4'">
          <h4 class="text-subtitle-2 font-weight-bold mb-2 mt-0" style="color: #191919">Description</h4>
          <p class="text-body-2 mb-0" style="color: #424242; line-height: 1.6">
            {{ course.courseDescription || 'No description available.' }}
          </p>
        </div>

        <!-- Course Details Grid -->
        <div :class="$vuetify.display.xs ? 'mb-3' : 'mb-4'">
          <h4 class="text-subtitle-2 font-weight-bold mb-2 mt-0" style="color: #191919">Course Information</h4>
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="3" lg="3" xl="3" class="mb-3 mb-md-0 pr-3">
              <div
                class="text-caption text-uppercase font-weight-bold mb-1"
                style="color: #777777; letter-spacing: 0.5px"
              >
                Length
              </div>
              <div class="text-body-2 font-weight-medium" style="color: #191919">{{ course.courseLength || '--' }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4" xl="4" class="mb-3 mb-md-0 pr-3">
              <div
                class="text-caption text-uppercase font-weight-bold mb-1"
                style="color: #777777; letter-spacing: 0.5px; white-space: nowrap"
              >
                Recommended prerequisite
              </div>
              <div class="text-body-2 font-weight-medium" style="color: #191919">
                {{ course.prerequisiteLabel || 'None' }}
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2" xl="3" class="mb-3 mb-md-0 pr-3">
              <div
                class="text-caption text-uppercase font-weight-bold mb-1"
                style="color: #777777; letter-spacing: 0.5px"
              >
                Hours per week
              </div>
              <div class="text-body-2 font-weight-medium" style="color: #191919">
                {{ course.courseEffortPerWeek || '--' }}
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="3" xl="2" class="pr-3">
              <div
                class="text-caption text-uppercase font-weight-bold mb-1"
                style="color: #777777; letter-spacing: 0.5px"
              >
                Course pacing
              </div>
              <div class="text-body-2 font-weight-medium" style="color: #191919">{{ course.coursePacing || '--' }}</div>
            </v-col>
          </v-row>
        </div>

        <!-- Credit Designations -->
        <div :class="$vuetify.display.xs ? 'mb-3' : 'mb-4'">
          <div class="text-caption text-uppercase font-weight-bold mb-1" style="color: #777777; letter-spacing: 0.5px">
            Credit Designations
          </div>
          <div
            class="text-body-2 font-weight-medium mb-2"
            style="color: #191919"
            v-html="course.creditDesignationsDisplay"
          />
          <a
            href="https://catalog.asu.edu/ug_gsr/"
            target="_blank"
            class="text-decoration-none d-inline-flex align-center"
            style="color: #8c1d40; font-size: 14px; font-weight: 500"
          >
            Learn more about credit designations
            <v-icon size="16" class="ml-1" style="color: #8c1d40">mdi-open-in-new</v-icon>
          </a>
        </div>

        <!-- View Full Course Details Button -->
        <div v-if="course.offering?.eaCourseUrl">
          <v-btn
            variant="text"
            :href="course.offering.eaCourseUrl"
            target="_blank"
            class="font-weight-bold pa-0 text-none"
            style="color: #8c1d40; font-size: 14px; height: auto; min-width: auto"
            :ripple="false"
          >
            View full course details
            <v-icon size="20" class="ml-2" style="color: #8c1d40">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CourseDetailsPanel',

  props: {
    /**
     * Course object from V2 API
     */
    course: {
      type: Object,
      required: true
    },

    /**
     * Whether the panel is open
     */
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  emits: ['close']
});
</script>

<style scoped>
/* Smooth expand/collapse animation */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 1000px;
}
</style>
